module.exports = "/images/location.svg";